import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { decryption, encryption } from '../../common/enc_dec';
import { courseLesson, courseListing, downloadCertificate, trendingCourseList, userEnrolledCourse } from '../../api/apiHandler';
import CourseRatingReviewModal from '../../modals/courseRatingReviewModal/courseRatingReviewModal';
import { Loading } from '../../components/loading/loading';
import { formatDuration } from '../../common/utilityFunctions';
import TrainerRatingReviewModal from '../../modals/trainerRatingReviewModal/trainerRatingReviewModal';
import { useTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate";
import '../../i18';

const StartCourse = () => {
    const { t } = useTranslation();
    const params = useParams();
    const decryptedData = decryption(params.data);
    const [isLoading, setIsLoading] = useState(true);
    const [course, setCourse] = useState([]);
    const [similarCourses, setSimilarCourses] = useState([]);
    const [lessons, setLessons] = useState([]);
    const [isRatingReviewModalOpen, setIsRatingReviewModalOpen] = useState(false);
    const [selectedCourseId, setSelectedCourseId] = useState(null);
    const [certificate, setCertificate] = useState([]);
    const [isTrainerRatingReviewModalOpen, setIsTrainerRatingReviewModalOpen] = useState(false);
    const [selectedTrainerId, setSelectedTrainerId] = useState(null);
    const [trendingCourse, setTrendingCourse] = useState([]);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            await getCourseDetails();
            await getSimilarCourse();
            await getCourseLesson();
            await getTrendingCourse();
            setIsLoading(false);
        };

        fetchData();
    }, []);

    const getCourseDetails = async () => {
        const response = await userEnrolledCourse({
            course_id: decryptedData.course_id,
            is_random_test: false,
            is_completed: decryptedData.is_completed,
            is_test_completed: false
        });
        if (response?.code === 200) {
            setCourse(response?.data);
        }
        else {
            setCourse("");
        }
    };

    const getSimilarCourse = async () => {
        const response = await courseListing({
            category_id: decryptedData.category_id,
            language: decryptedData.language,
            is_purchage: false,
            limit: 3,
            page: pageToken
        });
        if (response?.code == 200) {
            setSimilarCourses(response?.data?.data);
            setTotalPage(response.data.paging);
        }
        else {
            setSimilarCourses("");
        }
    };

    useEffect(() => {
        getSimilarCourse();
    },[pageToken]);

    const getCourseLesson = async () => {
        const response = await courseLesson({
            course_id: decryptedData.course_id,
            language: decryptedData.language
        })
        if (response?.code == 200) {
            setLessons(response?.data?.data)
        }
    }

    const getTrendingCourse = async () => {
        const trendingCourseResponse = await trendingCourseList({
            language: decryptedData.language,
        })
        if (trendingCourseResponse?.code == 200) {
            setTrendingCourse([trendingCourseResponse?.data?.data[0]])
        }
    }

    const handleOpenRatingReviewModal = (courseId) => {
        setSelectedCourseId(courseId);
        setIsRatingReviewModalOpen(true);
    }

    const handleOpenTrainerRatingReviewModal = (trainerId) => {
        setSelectedTrainerId(trainerId);
        setIsTrainerRatingReviewModalOpen(true);
    }

    const handleDownloadCertificate = async (courseId) => {
        const certificateResponse = await downloadCertificate({
            course_id: courseId
        })

        if (certificateResponse.code === 200) {
            setCertificate(certificateResponse?.data);
            window.open(certificateResponse?.data?.certificate, '_blank');
        }
    }

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return (
            <Loading />
        );
    }
    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 mt-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="course-course-detaila-inner">
                                <div className="details-inner">
                                    {course?.user_course?.assign_trainer[0] ? (
                                        <div className="emt-user">
                                            <span className="u-thumb">
                                                <img src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="author" />
                                            </span>
                                            <span className="align-self-center">{course?.user_course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                        </div>
                                    ) : (
                                        <div className="emt-user"></div>
                                    )}
                                    <div className="CourseheadingMainBox">
                                        <h3 className="title">{course?.user_course?.course_category?.name}</h3>
                                        {course?.user_course?.file && (
                                            <a
                                                href={course?.user_course?.file}
                                                className="PdfLink"
                                                target='_blank'
                                                download
                                            >
                                                {t('pdf')}
                                                <img
                                                    src={process.env.PUBLIC_URL + "/assets/img/icon/download-pdf.svg"}
                                                    alt="download-pdf"
                                                    className="IconTwoZero"
                                                />
                                            </a>
                                        )}
                                    </div>
                                </div>
                                <div className="thumb">
                                    <img src={course?.user_course?.image} alt="" width={730}
                                        height={315} style={{ objectFit: "cover" }} />
                                </div>
                                <div className="course-details-nav-tab text-center">
                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className="nav-link active"
                                                id="tab1-tab"
                                                data-toggle="tab"
                                                href="#tab1"
                                                role="tab"
                                                aria-controls="tab1"
                                                aria-selected="true"
                                            >
                                                {t('Description')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="tab2-tab"
                                                data-toggle="tab"
                                                href="#tab2"
                                                role="tab"
                                                aria-controls="tab2"
                                                aria-selected="false"
                                            >
                                                {t('courseList')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="tab4-tab"
                                                data-toggle="tab"
                                                href="#tab4"
                                                role="tab"
                                                aria-controls="tab4"
                                                aria-selected="false"
                                            >
                                                {t('review')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content" id="myTabContent">
                                    <div
                                        className="tab-pane fade show active"
                                        id="tab1"
                                        role="tabpanel"
                                        aria-labelledby="tab1-tab"
                                    >
                                        <div className="course-details-content">
                                            <h4>{course?.user_course?.name}</h4>
                                            <div className="CourseheadingMainBox">
                                                <ul className="LassonsUl">
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{course?.user_course?.total_lession} {t('lessons')}</p>
                                                    </li>
                                                    <li className="dots" />
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{formatDuration(course?.user_course?.duration, t)}</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <p>
                                                {course?.user_course?.description}
                                            </p>
                                            {/* <div className="row pt-4">
                                                <div className="col-sm-6">
                                                    <ul className="single-list-wrap">
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Metus interdum metus
                                                        </li>
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Ligula cur maecenas
                                                        </li>
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Fringilla nulla
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-sm-6 mt-3 mt-sm-0">
                                                    <ul className="single-list-wrap">
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Metus interdum metus
                                                        </li>
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Ligula cur maecenas
                                                        </li>
                                                        <li className="single-list-inner style-check-box">
                                                            <i className="fa fa-check" /> Fringilla nulla
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                                        <div className="course-details-content">
                                            <ul className="course-details-content-ul">
                                                {lessons.map((lesson, index) => (
                                                    <li key={lesson.id} className={`course-details-content-li ${lesson.user_lession?.is_completed ? 'completed-lesson' : ''}`}>
                                                        <div className="course-details-content-link">
                                                            {/* <Link to={`/lesson/${encodeURIComponent(encryption({ lesson_id: lesson.id, lesson_video: lesson.video, course_id: decryptedData.course_id }, true))}`}
                                                            
                                                        > */}
                                                            <div className="CourseLinkOne">
                                                                <span className="CourseNumber">{String(index + 1)}</span>
                                                                <div className='w-100'>
                                                                    <Link to={`/lesson/${encodeURIComponent(encryption({ lesson_id: lesson.id, lesson_video: lesson.video, course_id: decryptedData.course_id }, true))}`}
                                                                        className='w-100'
                                                                    >
                                                                        <p className="Coursename">{lesson.title}</p>
                                                                        <p className="CourseTime">{formatDuration(lesson.duration, t)}</p>
                                                                    </Link>
                                                                    {lesson.file && (
                                                                        <a
                                                                            href={lesson.file}
                                                                            className="PdfLink"
                                                                            target='_blank'
                                                                            download
                                                                            style={{ zIndex: 100, position: "relative", right: "0px" }}
                                                                        >
                                                                            <img
                                                                                src={process.env.PUBLIC_URL + "/assets/img/icon/download-pdf.svg"}
                                                                                alt="download-pdf"
                                                                                className="IconTwoZero"
                                                                            />
                                                                            {t('pdf')}
                                                                        </a>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <Link to={`/lesson/${encodeURIComponent(encryption({ lesson_id: lesson.id, lesson_video: lesson.video, course_id: decryptedData.course_id }, true))}`}
                                                            >
                                                                <div className="CoursePlayBtn">
                                                                    <img
                                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/playicon.svg"}
                                                                        alt="playicon"
                                                                        className="img-cover"
                                                                    />
                                                                </div>
                                                            </Link>
                                                            {/* </Link> */}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            {lessons.length === 0 && (
                                                <p>{t('noLesson')}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className="tab-pane fade"
                                        id="tab4"
                                        role="tabpanel"
                                        aria-labelledby="tab4-tab"
                                    >
                                        <div className="Two text-end">
                                            <Link to={`/rating-and-review/${encodeURIComponent(encryption({ course_id: course?.course_id }, true))}`}
                                                className="ViewAllReviewLink mr-4"
                                            >
                                                {t('viewReview')}
                                            </Link>
                                            <a
                                                className="ViewAllReviewLink"
                                                href='#'
                                                onClick={(e) => {
                                                    e.preventDefault(); // Prevent default link behavior
                                                    handleOpenRatingReviewModal(decryptedData.course_id);
                                                }}
                                            >
                                                {t('writeReview')}
                                            </a>
                                        </div>
                                        {course?.user_course?.assign_trainer[0] ? (
                                            <div className="TrainerDetailsMainBox">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="CourseheadingMainBox m-0">
                                                            <h4 className="m-0">{t('trainerDetails')}</h4>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 TrainerDetailsGride">
                                                        <div className="TrainerDetailsSliderMain">
                                                            <div
                                                                className="TrainerDetailsSlider"
                                                                id="TrainerDetailsSlider"
                                                            >
                                                                <div className="TrainerDetailsSliderItem">
                                                                    <div className="TrainerDetailsSliderCard">
                                                                        <div className="TrainerDetailsSliderCardHeader">
                                                                            <img
                                                                                src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'}
                                                                                alt="reviewimg"
                                                                                className="img-cover"
                                                                            />
                                                                        </div>
                                                                        <div className="TrainerDetailsSliderCardBody">
                                                                            <div className="chatBox">
                                                                                <div>
                                                                                    <h5 className="TrainerName">{course?.user_course?.assign_trainer[0]?.trainer_details?.full_name}</h5>
                                                                                </div>
                                                                                <Link to="/chat" state={{ user_id: course?.user_course?.assign_trainer[0]?.trainer_details?.id, role: "trainer" }} className="Chatlink">
                                                                                    <img
                                                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/chaticon.svg"}
                                                                                        alt="chaticon"
                                                                                        className="chaticon"
                                                                                    />
                                                                                    {t('chat')}
                                                                                </Link>
                                                                            </div>
                                                                            {course?.user_course?.assign_trainer[0]?.trainer_details?.experience == 0 ? '' : (
                                                                                <p className="TrainerExperience">
                                                                                    {course?.user_course?.assign_trainer[0]?.trainer_details?.experience} {t('yearsIn')} {course?.user_course?.assign_trainer[0]?.trainer_details?.industry}
                                                                                </p>
                                                                            )}
                                                                            <div className="Rating">
                                                                                <i className="fa fa-star" /> {course?.user_course?.assign_trainer[0]?.trainer_details?.avg_review}
                                                                                <span>({course?.user_course?.assign_trainer[0]?.trainer_details?.total_review} {t('reviews')})</span>
                                                                            </div>
                                                                            <p className="Certifiedtext">
                                                                                {course?.user_course?.assign_trainer[0]?.trainer_details?.trainer_certification[0]?.name || ''}
                                                                            </p>
                                                                            <div className="Two mt-2">
                                                                                <Link to={`/trainer-rating-and-review/${encodeURIComponent(encryption({ trainer_id: course?.user_course?.assign_trainer[0]?.trainer_details?.id }, true))}`}
                                                                                    className="ViewAllReviewLink mr-4"
                                                                                >
                                                                                    {t('viewReview')}
                                                                                </Link>
                                                                                <a
                                                                                    className="ViewAllReviewLink"
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault(); // Prevent default link behavior
                                                                                        handleOpenTrainerRatingReviewModal(course?.user_course?.assign_trainer[0]?.trainer_details?.id);
                                                                                    }}
                                                                                >
                                                                                    {t('writeReview')}
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="TrainerDetailsMainBox">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="CourseheadingMainBox m-0">
                                                            <h4 className="m-0">{t('adminDetails')}</h4>
                                                        </div>
                                                    </div>
                                                    <div className="col-6 TrainerDetailsGride">
                                                        <div className="TrainerDetailsSliderMain">
                                                            <div
                                                                className="TrainerDetailsSlider"
                                                                id="TrainerDetailsSlider"
                                                            >
                                                                <div className="TrainerDetailsSliderItem">
                                                                    <div className="TrainerDetailsSliderCard">
                                                                        <div className="TrainerDetailsSliderCardHeader p-2">
                                                                            <img
                                                                                src={course?.user_course?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + "/assets/img/logo-new.svg"}
                                                                                alt="reviewimg"
                                                                                className="img-cover"
                                                                            />
                                                                        </div>
                                                                        <div className="TrainerDetailsSliderCardBody">
                                                                            <div className="chatBox">
                                                                                <div>
                                                                                    <h5 className="TrainerName">{t('Admin')}</h5>
                                                                                </div>
                                                                                <Link to="/chat" state={{ user_id: 1, role: "admin" }} className="Chatlink">
                                                                                    <img
                                                                                        src={process.env.PUBLIC_URL + "/assets/img/icon/chaticon.svg"}
                                                                                        alt="chaticon"
                                                                                        className="chaticon"
                                                                                    />
                                                                                    {t('chat')}
                                                                                </Link>
                                                                            </div>
                                                                            {/* <p className="TrainerExperience">
                                                                                {course?.user_course?.assign_trainer[0]?.trainer_details?.experience} {t('yearsIn')} {course?.user_course?.assign_trainer[0]?.trainer_details?.industry}
                                                                            </p>
                                                                            <div className="Rating">
                                                                                <i className="fa fa-star" /> {course?.user_course?.assign_trainer[0]?.trainer_details?.avg_review}
                                                                                <span>({course?.user_course?.assign_trainer[0]?.trainer_details?.total_review} {t('reviews')})</span>
                                                                            </div>
                                                                            <p className="Certifiedtext">
                                                                                Certified XYZ Specialist
                                                                            </p>
                                                                            <div className="Two mt-2">
                                                                                <Link to={`/trainer-rating-and-review/${encodeURIComponent(encryption({ trainer_id: course?.user_course?.assign_trainer[0]?.trainer_details?.id }, true))}`}
                                                                                    className="ViewAllReviewLink mr-4"
                                                                                >
                                                                                    {t('viewReview')}
                                                                                </Link>
                                                                                <a
                                                                                    className="ViewAllReviewLink"
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault(); // Prevent default link behavior
                                                                                        handleOpenTrainerRatingReviewModal(course?.user_course?.assign_trainer[0]?.trainer_details?.id);
                                                                                    }}
                                                                                >
                                                                                    {t('writeReview')}
                                                                                </a>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="td-sidebar">
                                {lessons.every(lesson => lesson.user_lession?.is_completed) && (!course.is_test_completed) && (
                                    <div className="">
                                        <Link to={`/start-test/${encodeURIComponent(encryption({ course_id: course?.course_id, course_name: course?.user_course?.name }, true))}`} className="btn btn-base btn-radius mb-3 w-100">
                                            {t('startTest')}
                                        </Link>
                                        {/* <Link to={`/test`} className="btn btn-base btn-radius mb-3 w-100">
                                            {t('startTest')}
                                        </Link> */}
                                    </div>
                                )}
                                {course.is_test_completed && (
                                    <div className="">
                                        <button className='btn btn-base btn-radius mb-3 w-100'
                                            onClick={() => handleDownloadCertificate(course?.course_id)}
                                        >
                                            {t('downloadCertificate')}
                                        </button>
                                    </div>
                                )}
                                {trendingCourse?.filter(Boolean).length > 0 > 0 && (
                                    <div className="widget">
                                        <h4 className="widget-title">{t('trendingCourse')}</h4>
                                        {trendingCourse.map((course) => (
                                            <div className="single-course-inner" key={course?.id}>
                                                <Link
                                                    to={course?.is_purchage
                                                        ? `/start-course/${encodeURIComponent(encryption({
                                                            course_id: course?.id,
                                                            category_id: course?.category_id,
                                                            language: course?.language,
                                                            is_completed: false
                                                        }, true))}`
                                                        : `/course-details/${encodeURIComponent(encryption({
                                                            id: course?.id,
                                                            category_id: course?.category_id,
                                                            language: course?.language
                                                        }, true))}`}
                                                    className="thumb"
                                                >
                                                    <img src={course?.image} alt="img" />
                                                </Link>
                                                <div className="details">
                                                    <Link
                                                        to={course?.is_purchage
                                                            ? `/start-course/${encodeURIComponent(encryption({
                                                                course_id: course?.id,
                                                                category_id: course?.category_id,
                                                                language: course?.language,
                                                                is_completed: false
                                                            }, true))}`
                                                            : `/course-details/${encodeURIComponent(encryption({
                                                                id: course?.id,
                                                                category_id: course?.category_id,
                                                                language: course?.language
                                                            }, true))}`}
                                                        className="details-inner"
                                                    >
                                                        <div className="d-flex justify-content-between mb-3">
                                                            <p className="CardMainHeading">{course?.course_category?.name}</p>
                                                            {course?.assign_trainer && course?.assign_trainer.length > 0 && (
                                                                <div className="emt-user">
                                                                    <span className="u-thumb">
                                                                        <img src={course?.assign_trainer[0]?.trainer_details?.image} alt="img" />
                                                                    </span>
                                                                    <span className="align-self-center">{course?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <h6 className="CardMainSubHeading text-truncate-2">
                                                            {course.name}
                                                        </h6>
                                                        <div className="LassonsMain">
                                                            <ul className="LassonsUl">
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">{course?.total_lession} {t('lessons')}</p>
                                                                </li>
                                                                <li className="dots" />
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">{formatDuration(course?.duration, t)}</p>
                                                                </li>
                                                                <li className="dots" />
                                                                <li className="LassonsLi">
                                                                    <p className="Lessonstext">
                                                                        <strong>{course?.validity}</strong> {t('daysValidity')}
                                                                    </p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </Link>
                                                    <div className="emt-course-meta">
                                                        <div className="LassonsCardFooter">
                                                            <ul className="LassonsCardFooterUl">
                                                                <li className="LassonsCardFooterLi">
                                                                    <div className="rating">
                                                                        <i className="fa fa-star" /> {course?.avg_review}
                                                                        <span>({course?.total_review})</span>
                                                                    </div>
                                                                </li>
                                                                <li className="LassonsCardFooterLi">
                                                                    <div className="price">
                                                                        <span>₹{course?.price}</span>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-5">
                        {similarCourses && similarCourses.filter(courseItem => courseItem.id !== decryptedData.course_id && !courseItem.is_purchage).length > 0 &&
                            <h4 className='text-center'>{t('similarCourses')}</h4>
                        }
                        {similarCourses && similarCourses.length > 0 && similarCourses.filter(courseItem => courseItem.id !== decryptedData.course_id && !courseItem.is_purchage).map((courseItem) => (
                            <div className="col-lg-4 col-md-6 CourseGride" key={courseItem.id}>
                                <div className="single-course-inner">
                                    <Link to={`/course-details/${encodeURIComponent(encryption({
                                        id: courseItem.id, category_id: courseItem.category_id, language: courseItem.language
                                    }, true))}`} className="thumb">
                                        <img src={courseItem.image} alt="Course" />
                                    </Link>
                                    <div className="details">
                                        <Link to={`/course-details/${encodeURIComponent(encryption({
                                            id: courseItem.id, category_id: courseItem.category_id, language: courseItem.language
                                        }, true))}`} className="details-inner">
                                            <div className="d-flex justify-content-between mb-3">
                                                <p className="CardMainHeading">{courseItem?.course_category.name}</p>
                                                {courseItem?.assign_trainer[0] ? (
                                                    <div className="emt-user">
                                                        <span className="u-thumb">
                                                            <img src={courseItem?.assign_trainer[0]?.trainer_details?.image || process.env.PUBLIC_URL + '/assets/img/testimonial/review1.png'} alt="author" />
                                                        </span>
                                                        <span className="align-self-center">{courseItem?.assign_trainer[0]?.trainer_details?.full_name}</span>
                                                    </div>
                                                ) : (
                                                    <div className="emt-user"></div>
                                                )}
                                            </div>
                                            <h6 className="CardMainSubHeading text-truncate-2">{courseItem.name}</h6>
                                            <div className="LassonsMain">
                                                <ul className="LassonsUl">
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{courseItem.total_lession} {t('lessons')}</p>
                                                    </li>
                                                    <li className="dots" />
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">{formatDuration(courseItem.duration, t)}</p>
                                                    </li>
                                                    <li className="dots" />
                                                    <li className="LassonsLi">
                                                        <p className="Lessonstext">
                                                            <strong>{courseItem.validity}</strong> {t('daysValidity')}
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </Link>
                                        <div className="emt-course-meta">
                                            <div className="LassonsCardFooter">
                                                <ul className="LassonsCardFooterUl">
                                                    <li className="LassonsCardFooterLi">
                                                        <div className="rating">
                                                            <i className="fa fa-star" /> {courseItem.avg_review}
                                                            <span>({courseItem.total_review})</span>
                                                        </div>
                                                    </li>
                                                    <li className="LassonsCardFooterLi">
                                                        <div className="price">
                                                            <span>₹{courseItem.price}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {similarCourses && similarCourses.filter(courseItem => courseItem.id !== decryptedData.course_id && !courseItem.is_purchage).length > 0  && (
                            <ReactPaginate
                                className='pagination mt-4'
                                breakLabel="..."
                                nextLabel={`${t('next')} >`}
                                previousLabel={`< ${t('Previous')} `}
                                renderOnZeroPageCount={null}
                                onPageChange={handlePageClick}
                                pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                            />
                        )}
                    </div>
                </div>
                <CourseRatingReviewModal
                    isOpen={isRatingReviewModalOpen}
                    isClose={() => setIsRatingReviewModalOpen(false)}
                    courseId={selectedCourseId}
                />
                <TrainerRatingReviewModal
                    isOpen={isTrainerRatingReviewModalOpen}
                    isClose={() => setIsTrainerRatingReviewModalOpen(false)}
                    trainerId={selectedTrainerId}
                />
            </div>
        </>
    )
}

export default StartCourse;